// extracted by mini-css-extract-plugin
module.exports = {"c1fpn3pe":"c1fpn3pe","low-capability":"low-capability","s7qhz68":"s7qhz68","ovai82f":"ovai82f","c1va2ry":"c1va2ry","focused":"focused","n1uipnfe":"n1uipnfe","active":"active"};